import { type FormEvent, useState } from "react";
import type { PasswordSetupMode } from "./authCallbackIntent";

interface PasswordSetupScreenProps {
  mode: PasswordSetupMode;
  email: string | undefined;
  onSubmit: (password: string) => Promise<void>;
  onCancel: () => Promise<void>;
}

export function PasswordSetupScreen({ mode, email, onSubmit, onCancel }: PasswordSetupScreenProps) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string>();
  const [password, setPassword] = useState("");
  const [again, setAgain] = useState("");

  async function save(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError(undefined);
    if (password.length < 8) {
      setError("رمز عبور باید حداقل ۸ نویسه داشته باشد.");
      return;
    }
    if (password !== again) {
      setError("رمز عبور و تکرار آن یکسان نیستند.");
      return;
    }
    setBusy(true);
    try {
      await onSubmit(password);
    } catch {
      setError("ثبت رمز عبور انجام نشد. لینک ممکن است منقضی شده باشد؛ دوباره تلاش کنید.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="app-shell" dir="rtl">
      <section className="section-card" style={{ margin: "auto", width: "min(92vw, 440px)" }}>
        <p className="section-kicker">Discus AI V2</p>
        <h1>{mode === "invite" ? "فعال‌سازی حساب" : "بازیابی رمز عبور"}</h1>
        <p className="section-note">
          {email ? `حساب: ${email} — ` : ""}
          برای ادامه، یک رمز عبور جدید و اختصاصی انتخاب کنید.
        </p>
        <form className="operation-form" onSubmit={(event) => void save(event)}>
          <label className="operation-field">
            رمز عبور جدید
            <input
              type="password"
              autoComplete="new-password"
              minLength={8}
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </label>
          <label className="operation-field">
            تکرار رمز عبور
            <input
              type="password"
              autoComplete="new-password"
              minLength={8}
              required
              value={again}
              onChange={(event) => setAgain(event.target.value)}
            />
          </label>
          {error ? (
            <p className="settings-warning" role="alert">
              {error}
            </p>
          ) : null}
          <button type="submit" className="primary-button large-button" disabled={busy}>
            {busy ? "در حال ثبت…" : "ثبت رمز و ورود به سالن"}
          </button>
        </form>
        <button
          type="button"
          className="text-button"
          disabled={busy}
          onClick={() => void onCancel()}
        >
          انصراف و خروج
        </button>
      </section>
    </main>
  );
}
